import {Component, ViewEncapsulation, ElementRef, Inject} from "@angular/core";
import {AuthService} from "../common/auth.service";
import {FormGroup, FormBuilder, Validators, FormControl} from "@angular/forms";

import * as $ from 'jquery';

@Component({
  templateUrl: './login.component.html',
  selector: 'login',
  styleUrls: [ './login.component.scss' ],
  encapsulation: ViewEncapsulation.None
})

export class LoginComponent {

  public loginForm: FormGroup;
  public showError = false;
  protected nativeElement:any =null;

  constructor(
    protected authService: AuthService,
    @Inject('isBrowser') protected isBrowser: boolean,
    @Inject(FormBuilder) formBuilder: FormBuilder,
    element:ElementRef,
  ) {
    this.nativeElement = element.nativeElement;
    this.loginForm = formBuilder.group({
      username: ["", Validators.required],
      password: ["", Validators.required]
    });
  }

  public ngAfterViewInit() {
    if(this.isBrowser) {
      this.nativeElement.querySelector('#login-button')
        .addEventListener('click', () => { this.showLoginPopup()});
    }
  }

  public showLoginPopup() {
    $('#loginpopup').modal();
  }

  public doLogin(event) {
    (this.loginForm.controls['username'] as FormControl).markAsTouched(true);
    (this.loginForm.controls['password'] as FormControl).markAsTouched(true);
    if(this.loginForm.controls['username'].valid && this.loginForm.controls['password'].valid) {
      this.authService.login(this.loginForm.value.username, this.loginForm.value.password).then(() => {
        this.showError = false;
        $('#loginpopup').modal('hide');
      }).catch((err) => {
        this.showError = true;
        console.log(err);
      })
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/login/login/login.component.ts